const config = {
  MAX_RECORDING_TIME: 10000,
  MAX_LISTENING_TIMEOUT: 5000,
  RECORDING_MODES: {
    TAP: 'tap',
    LONG_PRESS: 'longPress',
    WEBKIT_CONTINUES: 'continues'
  },
  COUNTER_SETTINGS: {
    MAX_LENGTH: 256,
    COUNTER_SHOWN_LENGTH: 200,
    WARNING_REMAINING_LENGTH: 20
  },
  ALERT_DELAY: 5000,
  ACCEPTABLE_FILE_TYPES: [
    // Image Types
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    // Video Types
    'video/mp4',
    'video/avi',
    'video/ogg',
    'video/flv',
    'video/wmv',
    'video/webm',
    // Document Types
    'application/pdf',
    'application/csv',
    'text/plain',
    'application/doc',
    'application/docx',
    'application/xls',
    'application/xlsx',
    'application/ppt',
    'application/pptx',
    // Libreoffice types
    'application/odt',
    'application/odp',
    'application/ott',
    'application/ods',
    'application/tsv'
  ],
  MAX_UPLOAD_LIMIT: 10485760, // 10 MB in bytes
  MAX_PROGRESS_LIMIT: 512000 // 500 KB in bytes
}
export default config
